import { render, staticRenderFns } from "./ProductInstallations.vue?vue&type=template&id=6a1fb5f4&"
import script from "./ProductInstallations.vue?vue&type=script&lang=js&"
export * from "./ProductInstallations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports